import { useFeature } from "byzantine";
import { RecipientDrawer, DRAWER_TYPES } from "../../RecipientDrawer";
import { RecipientDrawer as NewRecipientDrawer } from "../../../src/modules/recipientDrawer";
import type useWireRecipientDrawerState from "./useWireRecipientDrawerState";

interface WireFileImportRecipientDrawerProps {
  drawerState: ReturnType<typeof useWireRecipientDrawerState>;
}

const WireFileImportRecipientDrawer = ({
  drawerState,
}: WireFileImportRecipientDrawerProps) => {
  const isNewDrawerEnabled = useFeature().featureEnabled("recipient_drawer");
  const {
    isOpen,
    drawerType,
    selectedRecipientId,
    selectedRowIndex,
    handleCloseDrawer,
  } = drawerState;

  if (isNewDrawerEnabled) {
    return (
      <NewRecipientDrawer
        isOpen={isOpen}
        flow="wire"
        onClose={({ recipient }) =>
          handleCloseDrawer(recipient?.id, selectedRowIndex)
        }
        {...(drawerType === DRAWER_TYPES.edit && selectedRecipientId
          ? { mode: "edit", recipientId: selectedRecipientId }
          : { mode: "create" })}
      />
    );
  }

  return (
    <RecipientDrawer
      isOpen={isOpen}
      handleClose={handleCloseDrawer}
      drawerType={drawerType}
      recipientId={selectedRecipientId}
      rowIndex={selectedRowIndex}
      fromDomesticWireFlow
    />
  );
};

export default WireFileImportRecipientDrawer;
